(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();
(function (Service, Router, Handler, Controller, Config, Model, Helper, Validation, Message, Analytics, CustomDimension, $) {
    'use strict';

    // ==================================================
    // Llamada ajax generica
    // Params : {url} {data} {success} {error}
    // ==================================================
    Service.ajaxPost = function (url, data, done, error, options) {
        var sentHeader = ((!Helper.isEmpty(options) && 'sentHeader' in options) ? true : false);
        var showPreloader = ((!Helper.isEmpty(options) && 'showPreloader' in options) ? true : false);
        var hidePreloader = ((!Helper.isEmpty(options) && 'hidePreloader' in options) ? true : false);
        var api = ((!Helper.isEmpty(options) && 'paywallApi' in options) ? Config.apiPaywallUrl : Config.apiLoginUrl);

        var headers = {
            'X-Token': Model.Usuario.xToken || '',
            'X-Value': Model.Usuario.xValue || '',
            'X-Key': Model.Usuario.xKey || ''
        };
        showPreloader && Helper.showPreloader();
        $.ajax({
            url: api + url,
            type: 'POST',
            data: data || null,
            headers: (sentHeader == true ? headers : null),
            success: function (response, status, xhr) {
                //success && success(response,status,xhr);
            },
            error: function (response, status, xhr) {
                hidePreloader && Helper.hidePreloader();
                error && error(response);
            },
            complete: function (response, status, xhr) {
                if (Config.env === "develop") console.log("Load", url);
            }
        }).done(function (res, status, xhr) {
            Helper.setCanSubmit(true);
            hidePreloader && Helper.hidePreloader();
            done && done(JSON.parse(res), status, xhr);
        }).fail(function (jqXHR, textStatus, errorThrown) {
            //logger && logger.error("Service Fail", { "data": url, "jqXHR": jqXHR, "textStatus": textStatus, "errorThrown": errorThrown });
            Handler.failHandler(jqXHR.status);
        });
    }

    Service.startHotjar = function () {
        (function (h, o, t, j, a, r) {
            h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
            h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script'); r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
    }

    Service.createCustomDimension = function () {

        var withToken = Helper.isEmpty(Helper.readCookie('token'));
        var usuarioLogeado = withToken ? 'no' : 'yes';
        var payUser = Helper.isEmpty(Helper.readCookie('ProductoPremiumId')) ? 'no' : 'yes';
        var userId = Helper.readCookie('usuario%5Fid');
        var clubLN = Helper.readCookie('usuarioDetalleClubNacion');
        var notasLeidas = Helper.readCookie('countNotas');

        if (!CustomDimension.exist()) {
            CustomDimension.setRegistrado('no');
            CustomDimension.setSuscriptorType('N/A');
            CustomDimension.setUserId('');
            CustomDimension.save();
        }

        var CD = CustomDimension.get();

        if (!window.dataLayer) {
            window.dataLayer = [{}];
        }

        dataLayer[0].notasLeidas = notasLeidas ? notasLeidas : 0;
        dataLayer[0].usuarioLogeado = usuarioLogeado;
        dataLayer[0].usuarioRegistrado = CD.usuarioRegistrado;
        dataLayer[0].payUser = payUser;
        dataLayer[0].suscriptorType = CD.suscriptorType;
        dataLayer[0].userId = CD.userId;
        dataLayer[0].credentialType = clubLN ? clubLN : 'N/A';

        var notaPaywall = getNotaPaywall();

        if (notaPaywall) {
            dataLayer[0]['nota-PW'] = notaPaywall.Id;
            dataLayer[0]['url-nota-PW'] = notaPaywall.Url;
        }
    }

    function getNotaPaywall() {
        var callbackUrl = window.atob(Helper.getURLParameter1('callback'));

        var notaIdKey = '-nid';
        var notaIdKeyIndex = callbackUrl.indexOf(notaIdKey);

        if (notaIdKeyIndex < 0) {
            return null;
        }

        var notaUrlIndex = callbackUrl.lastIndexOf('/') + 1;
        var notaUrl = callbackUrl.substring(notaUrlIndex, notaIdKeyIndex);
        var notaId = callbackUrl.substring(notaIdKeyIndex + notaIdKey.length);

        return {
            Id: notaId,
            Url: notaUrl
        };
    }

    Service.startGoogleAnalytics = function () {
        (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
                (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date(); a = s.createElement(o),
                m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
        ga && ga('create', Config.gaId, 'auto');
    }

    Service.startGoogleTagManager = function () {
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&amp;l=' + l : ''; j.async = true; j.src =
                    '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', Config.gtmId);
    }

    Service.startComscore = function () {
        var _comscore = _comscore || [];
        _comscore.push({ c1: "2", c2: "6906398" });
        (function () {
            var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
            s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
            el.parentNode.insertBefore(s, el);
        })();
  }

    Service.startGoogleOptimize = function () {
        //Agregar a styles 
        //2.	<style>.async-hide { opacity: 0 !important} </style>
        (function (a, s, y, n, c, h, i, d, e) {
            s.className += ' ' + y; h.start = 1 * new Date;
            h.end = i = function () { s.className = s.className.replace(RegExp(' ?' + y), '') };
            (a[n] = a[n] || []).hide = h; setTimeout(function () { i(); h.end = null }, c); h.timeout = c;
        })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-GHV6': true });
    }

    Service.startEstadisticas = function () {
        var rand_no = Math.random();
        var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
        rand_no = Math.ceil(rand_no * 1000000000);
        $("body").append('<img src="https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=muropaywall&amp;servidor=' + ip + '&amp;nro=' + rand_no + '&amp;usuario=' + Helper.readCookie('usuario%5Fid') + '" width="1" height="1" />');
    }

    Service.mostrarError = function (message, analyticsError, error) {
        Analytics.error(analyticsError || message);
        LN.AppEvent.sendEvent('ERROR', message);
        console.log('{ Error: "' + error + '", Message: "' + message + '" }');
        Helper.callView('MOSTRAR_ERROR', {
            message: message,
            error: error
        });
        Model.Window.lastFlow = "";                 // Limpio el ultimo flow ejecutado
    }

    Service.isLogged = function (success, error) {
        Model.Usuario.xToken = Helper.readCookie("token");
        if (Helper.isEmpty(Model.Usuario.xToken) || Validation.Validators.temporary.test(Model.Usuario.xToken)) {
            error && error();
            return; 
        } 
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.code) && res.code === '0000') {
                Model.setMe(res);
                success && success();
            } else {
                error && error()
            }
        }, null, {
                sentHeader: true,
                showPreloader: true
            });
    }

    Service.ifLoggedReturnBack = function () {
        setInterval(function () {
            Service.isLogged()
        }, Config.returnBackInterval);
    }

    Service.logout = function (options) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Model.Usuario.xValue = Helper.readCookie("xvalue");
        Service.ajaxPost('/Usuario/Logout', Model.Usuario, function (res, status, xhr) {
            Service.smartlockSignOut();
            Helper.resetAll(function () {
                Helper.redirectToLogin();
            });
        }, function () {
            Service.smartlockSignOut();
            Helper.resetAll(function () {
                Helper.redirectToLogin();
            });
        }, { sentHeader: true }
        );

    }

    // ==================================================
    // Flow Service
    // ==================================================   

    Service.getFlow = function (flow, requestData, options) {
        var data = {
            flow: flow
        }
        // Activa el modo debug
        if (Config.debugMode === true) {
            data.debug = true;
            data.codeResult = Config.debugFlowData[flow].codeResult
        }

        if (!Helper.isEmpty(requestData)) data = $.extend(data, requestData);
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Paywall/GetFlow', data, function (res, status, xhr) {
            Model.Window.lastFlow = flow;
            Handler.flowHandler(flow, res, status, xhr, options);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true,
                hidePreloader: true
            });
    }


    // ==================================================
    // Servicios
    // ==================================================   
    Service.clienteObtener = function (cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/Obtener', null, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true,
                hidePreloader: true
            });
    }

    Service.clienteObtenerCrmId = function (dni, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/ObtenerCrmId', {
            dni: dni
        }, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true,
                hidePreloader: true
            });
    }

    Service.clienteGuardar = function (cliente, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/GuardarCliente', cliente, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true
            });
    }

    Service.clienteObtenerDatosFiliatorios = function (cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Cliente/ObtenerDatosFiliatorios', null, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true,
                hidePreloader: true
            });
    }

    Service.campanaObtener = function (id, cb) {
        // TODO : Validar que el return de campaña 374 sean dos planes de venta . 
        // TODO : Validar que el return de campaña 375 sea un solo plan de venta . 
        Model.Usuario.xToken = Helper.readCookie("token");
        //if (Config.campanasPermitidas.indexOf(id) === -1) throw new Error("No existe la campaña");

        // Se levanta desde "caché" los datos de campaña si ya se encuentra en el modelo la misma que estoy solicitando .  
        if (!Helper.isEmpty(Model.Campania) && Model.Campania.id == id) return cb({ code: "0000", message: "OK", response: Model.Campania });
        Service.ajaxPost('/Campania/Obtener', {
            id: id
        }, function (res, status, xhr) {
            Model.Campania = res.response;
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true
                // hidePreloader: true   
            });
    }


    Service.landingObtener = function (id, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
      
        // Se levanta desde "caché" los datos de campaña si ya se encuentra en el modelo la misma que estoy solicitando .  
        
        Service.ajaxPost('/Campania/ObtenerCampaniasAutomaticas', { 'id': id }, function (res, status, xhr) {
            Model.Landing = res.response;
            /*  HARCODING POR PABLO MELICCHIO*/
            if (Model.Landing.PlanesDeVenta[0].BajadaPlan.toUpperCase().indexOf("CLUB") >= 0) {
                Model.Landing.PlanesDeVenta[0].TieneCredencial = true;
            }
            Model.FormatearProductosBajadaLanding();
            /* NUNCA QUISE HACER ESTO*/
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true
                // hidePreloader: true   
            });
    }

    Service.domicilioNormalizar = function (address, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Domicilio/Normalizar', address, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true
            });
    }

    Service.domicilioCrear = function (address, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Domicilio/CrearDomicilio', address, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true
            });
    }

    Service.posdatarDomicilio = function (address, fn) {
        Model.Usuario.xToken = Helper.readCookie('token');
        Service.ajaxPost(
            '/Domicilio/PosdatarDomicilio',
            address,
            function (response, status, xhr) {
                fn(response, status, xhr);
            },
            function (xhr) {
              (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
            },
            {
                sentHeader: true,
                paywallApi: true
            }
        );
    }

    Service.iniciarVenta = function (data, cb) {

        Analytics.medicionCheckOut(Model.PlanElegido.nombre, Model.PlanElegido.precio);
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Venta/IniciarVenta', data, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
            sentHeader: true,
            paywallApi: true,
            showPreloader: true
        });
    }


    Service.pagoValidar = function (data, cb) {
        Model.Usuario.xToken = Helper.readCookie("token");
        Service.ajaxPost('/Pago/ValidarPago', data, function (res, status, xhr) {
            cb(res, status, xhr);
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                paywallApi: true,
                showPreloader: true,
                hidePreloader: true
            });
    }

    Service.obtenerMontoACobrar = function (data, cb) {
        Service.ajaxPost('/Venta/ObtenerMontoACobrar', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
        }, {
                paywallApi: true,
                sentHeader: true
            });

    }

    Service.procesarPago = function (data, cb) {

        Service.ajaxPost('/Venta/ProcesarPago', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
                paywallApi: true,
                sentHeader: true,
                showPreloader: true,
                hidePreloader:true
            });

    }

    Service.actualizarCookies = function (cb) {
        Service.ajaxPost('/Usuario/Me', false, function (res, status, xhr) {
            if (!Helper.isEmpty(res.response)) {
                var usuario = JSON.parse(res.response);
                Model.Usuario.ClubNacion = (usuario.Usuario.ClubNacion === undefined) ? "" : usuario.Usuario.ClubNacion;
                Helper.setupCookies(usuario.Usuario);

                (res.code == "0000") ? cb && cb(res, status, xhr) : Service.mostrarError(Message.Error['GENERAL'], Message.Analytics.Error['GENERAL']);
            }
        }, function (xhr) {
          (xhr.status === 403) ? Helper.redirectToLogin() : Service.mostrarError(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
        }, {
                sentHeader: true,
                showPreloader: true
            });
    }

    Service.asociarCredencial = function (data) {
        Service.ajaxPost('/Usuario/AsociarCredencial', data, function (res, status, xhr) {
            // Reseteo numero y tipo de DNI . Si salta error no puedo reemplazarlo . 
            // Si entro por combo 3 no lo tengo que cambiar, porque solo tengo que asignar credencial al DNI ingresado anteriormente . 
            if (Model.Cliente.comboElegido == Config.COMBO_BONIFICADO) {
                Model.Cliente.numeroDocumento = "";
                Model.Cliente.tipoDocumento = "";
            }
            Handler.asociarResponseHandler(res, status, xhr);
        }, null, {
                sentHeader: true,
                showPreloader: true,
                hidePreloader: true
            });
    }

    Service.validarPin = function (data, cb) {
        Helper.updateToken();
        Service.ajaxPost('/Pin/RedeemPin', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, null, {
                showPreloader: true,
                hidePreloader: true,
                paywallApi: true,
                sentHeader: true
            });
    }

    Service.validarPinReenviar = function (data, cb) {
        Service.ajaxPost('Pin/ReenviarCodigo', data, function (res, status, xhr) {
            cb & cb(res, status, xhr);
        }, null, {
                showPreloader: true,
                hidePreloader: true,
                paywallApi: true,
                sentheader: true
            });
    }

    Service.ventaFacebook = function (data, cb) {

        Service.ajaxPost('/FacebookSubscription/Subscribe', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
                paywallApi: true,
                sentHeader: true,
                showPreloader: true,
                hidePreloader: true
            });

    }


    Service.ventaFacebookYaTenia = function (data, cb) {

        Service.ajaxPost('/FacebookSubscription/LogIntoAccount', data, function (res, status, xhr) {
            cb && cb(res, status, xhr);
        }, function (xhr) {
            console.log('error ' + xhr);
        }, {
                paywallApi: true,
                sentHeader: true,
                showPreloader: true,
                hidePreloader: true
            });

    }


    Service.guardarNewsletter = function (data) {
        return new Promise((resolve, reject) => {
            Service.ajaxPost('/Newsletters/Actualizar', data, function (res, status, xhr) {
                resolve(res, status, xhr);
            }, function (xhr) {
                (xhr.status === 403) ? Helper.redirectToLogin() : reject(Message.Error[xhr.status], Message.Analytics.Error[xhr.status]);
            }, {
                    sentHeader: true,
                    showPreloader: true,
                    hidePreloader: true
                });
        })   
    }

    Service.obtenerNewsletter = function () {
        return new Promise((resolve, reject) => {
            Service.ajaxPost('/Usuario/ObtenerServicios', null, function (res, status, xhr) {
                resolve(res, status, xhr);
            }, function (xhr) {
                (xhr.status === 403) ? Helper.redirectToLogin() : reject(Message.Analytics.Error[xhr.status]);
            }, {
                    sentHeader: true,
                    showPreloader: true,
                    hidePreloader: true
                });
        })

    }

    // ==================================================
    // Setup App
    // ==================================================   
    Service.setup = function () {
        Model.setUsuario();
        Validation.cleanOnFocusIn()
        Validation.validateOnFocus();
        Validation.validateOnKeyDownOnlyNumbers();
        Helper.placeHolder();
        Router.handle();
    }

    Service.smartlockSignOut = function () {
        smartlock && smartlock.signOut();
    }

    Service.wallConfig = function () {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: Config.urlWallConfig,
                type: 'GET',
                dataType: 'json',
                success: function (response) {
                    Model.wallConfig = response
                    resolve()
                }
            });
        })
    }

})(LN.Service, LN.Router, LN.Handler, LN.Controller, LN.Config, LN.Model, LN.Helper, LN.Validation, LN.Message, LN.Analytics, LN.CustomDimension, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/core/service.js